// extracted by mini-css-extract-plugin
export default {"number":"ItemPrice-module__number___4Hu2P","primary":"ItemPrice-module__primary___JqCOf","crossed":"ItemPrice-module__crossed___mjlnL"};